import { render, staticRenderFns } from "./AccountValidation.vue?vue&type=template&id=4bf05928&scoped=true&"
import script from "./AccountValidation.vue?vue&type=script&lang=js&"
export * from "./AccountValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf05928",
  null
  
)

export default component.exports